import React from "react";

export type AlertVariant = "success" | "error" | "warning" | "info";

export interface AlertProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "role"> {
  variant?: AlertVariant;
  dismissible?: boolean;
  onDismiss?: () => void;
  className?: string;
  children?: React.ReactNode;
}

function getA11yProps(variant: AlertVariant) {
  if (variant === "error" || variant === "warning") {
    return {
      role: "alert" as const,
      "aria-live": "assertive" as const,
    };
  }

  return {
    role: "status" as const,
    "aria-live": "polite" as const,
  };
}

const Alert: React.FC<AlertProps> = ({
  variant = "info",
  dismissible = false,
  onDismiss,
  className,
  children,
  ...rest
}) => {
  const classes = ["ui-alert", `ui-alert--${variant}`, className].filter(Boolean).join(" ");

  return (
    <div className={classes} {...getA11yProps(variant)} {...rest}>
      <div className="ui-alert__content">{children}</div>
      {dismissible ? (
        <button type="button" className="ui-alert__dismiss" aria-label="Fermer" onClick={onDismiss}>
          ×
        </button>
      ) : null}
    </div>
  );
};

export default Alert;
